import DOMPurify from 'isomorphic-dompurify';

/**
 * Sanitize admin/CMS-authored HTML before injecting it via
 * dangerouslySetInnerHTML. Storefront-page bodies, rich-text sections and blog
 * content are authored in TinyMCE (which exposes a raw "Code" editor), so the
 * stored HTML is untrusted — a lower-privilege content editor could otherwise
 * plant <script>/onerror payloads that run in every visitor's browser.
 *
 * Uses DOMPurify's default HTML profile: keeps normal formatting (headings,
 * lists, links, images, tables, emphasis) and strips scripts, event handlers,
 * and javascript:/data: URLs. Rich media embeds go through the dedicated
 * VideoSection, so iframes are intentionally NOT allowed here.
 *
 * Runs on both server (SSR, via jsdom) and client via isomorphic-dompurify.
 */
export function sanitizeCmsHtml(dirty: string | null | undefined): string {
  if (!dirty || typeof dirty !== 'string') return '';
  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
}
